import styled from "@emotion/styled";
import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "../atoms/Icon";
import { Button } from "../atoms/Button";
import { Text } from "../atoms/Text";

interface HeaderNavigationProps {
  title: string;
  rightAction?: ReactNode;
  className?: string;
}

const Navigation = styled.div`
  position: relative;
  top: -8px;
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const LogoutButton = styled(Button)`
  width: 24px;
  height: 24px;
`;

const Title = styled(Text)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: ${(props) => props.theme.typography.h5.fontSize};
  font-weight: ${(props) => props.theme.typography.h5.fontWeight};
  line-height: ${(props) => props.theme.typography.h5.lineHeight};
  color: ${(props) => props.theme.colors.neutral.white};
`;

export const HeaderNavigation = ({
  title,
  rightAction,
  className,
}: HeaderNavigationProps) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    navigate("/logout");
  };

  return (
    <Navigation className={className}>
      <Title variant="h5" weight="bold">
        {title}
      </Title>
      {rightAction || (
        <LogoutButton onClick={handleLogout} ariaLabel="Cerrar sesión">
          <Icon name="logout" color="white" size={24} />
        </LogoutButton>
      )}
    </Navigation>
  );
};
